import { CalendarDays, X } from "lucide-react";
import { useSearchParams } from "react-router-dom";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const MONTHS_FULL = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const monthLabel = (m: string) => (m ? `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}` : "");

export function useMonthFilter(): [string, (m: string) => void] {
  const [params, setParams] = useSearchParams();
  const month = params.get("bulan") || "";
  const set = (m: string) => { const p = new URLSearchParams(params); if (m && m < thisMonth()) p.set("bulan", m); else p.delete("bulan"); setParams(p, { replace: true }); };
  return [month, set];
}

export function MonthFilter({ value, onChange, testId = "month-filter", years = 3 }: { value: string; onChange: (m: string) => void; testId?: string; years?: number }) {
  const active = !!value;
  const cur = thisMonth();
  const curY = Number(cur.slice(0, 4));
  const sel = value || cur;
  const y = sel.slice(0, 4);
  const m = sel.slice(5, 7);
  const yearOpts = Array.from({ length: years }, (_, i) => String(curY - i));
  const pick = (ny: string, nm: string) => {
    const next = `${ny}-${nm}`;
    onChange(next > cur ? cur : next);
  };
  const cls = "bg-transparent text-xs font-semibold outline-none cursor-pointer rounded-md px-1.5 py-1 hover:bg-muted";
  return (
    <div className={`inline-flex items-center gap-0.5 rounded-lg border bg-card pl-2 pr-1 py-0.5 ${active ? "border-primary ring-1 ring-primary/30" : ""}`} data-testid={testId}>
      <CalendarDays className="h-4 w-4 text-muted-foreground mr-1" />
      <select value={m} onChange={(e) => pick(y, e.target.value)} className={cls} data-testid={`${testId}-month`} aria-label="Pilih bulan">
        {MONTHS_FULL.map((label, i) => { const mm = String(i + 1).padStart(2, "0"); return <option key={mm} value={mm} disabled={`${y}-${mm}` > cur}>{label}</option>; })}
      </select>
      <select value={y} onChange={(e) => pick(e.target.value, m)} className={cls} data-testid={`${testId}-year`} aria-label="Pilih tahun">
        {yearOpts.map((yy) => <option key={yy} value={yy}>{yy}</option>)}
      </select>
      {active ? (
        <button type="button" onClick={() => onChange("")} className="inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-[11px] font-semibold text-primary hover:bg-primary/10" data-testid={`${testId}-reset`} title="Kembali ke bulan berjalan"><X className="h-3.5 w-3.5" /> Bulan ini</button>
      ) : (
        <span className="text-[11px] text-muted-foreground px-1.5">bulan ini</span>
      )}
    </div>
  );
}
